import { render, staticRenderFns } from "./PartBackToTop.vue?vue&type=template&id=0a58d5f2&scoped=true&"
import script from "./PartBackToTop.vue?vue&type=script&lang=js&"
export * from "./PartBackToTop.vue?vue&type=script&lang=js&"
import style0 from "./PartBackToTop.vue?vue&type=style&index=0&id=0a58d5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a58d5f2",
  null
  
)

export default component.exports